import { motion, AnimatePresence } from "framer-motion";
import { useLocation } from "react-router-dom";

export const AnimatedRoute = ({ children }) => {
  const location = useLocation();

  return (
    <AnimatePresence>
      <motion.div
        key={location?.pathname}
        initial={{ opacity: 0, x: -25 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.5 }}
        style={{ height: "100%" }}>
        {children}
      </motion.div>
    </AnimatePresence>
  );
};
